const SITE_URL = "https://generator-contracte.com";
const ORG_NAME = "ContractGen";

export function buildArticleSchema({ title, description, date, url }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    datePublished: date,
    dateModified: date,
    author: { "@type": "Organization", name: ORG_NAME, url: SITE_URL },
    publisher: { "@type": "Organization", name: ORG_NAME, url: SITE_URL },
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
  };
}

export function buildBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.item,
    })),
  };
}

export function buildFAQSchema(faq) {
  if (!faq || !faq.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

// Parse legacy blog FAQ format: sections containing "intrebari frecvente" with strings like "Q — A"
export function buildFAQSchemaFromBlogSections(sections) {
  const faqSection = sections.find(
    (s) => s.title && s.title.toLowerCase().includes("intrebari frecvente") && Array.isArray(s.content)
  );
  if (!faqSection) return null;
  const faq = faqSection.content.map((item) => {
    const dashIndex = item.indexOf(" — ");
    return {
      q: dashIndex > -1 ? item.substring(0, dashIndex) : item,
      a: dashIndex > -1 ? item.substring(dashIndex + 3) : item,
    };
  });
  return buildFAQSchema(faq);
}

// Inject schemas as <script type="application/ld+json"> elements with stable IDs.
// Returns a cleanup function to remove them on unmount.
export function injectSchemas(schemas, idPrefix) {
  const valid = schemas.filter(Boolean);
  const ids = [];
  valid.forEach((schema, i) => {
    const id = `${idPrefix}-${i}`;
    ids.push(id);
    let script = document.getElementById(id);
    if (!script) {
      script = document.createElement("script");
      script.id = id;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  });
  return () => {
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.remove();
    });
  };
}
